module.exports = __webpack_public_path__ + "static/img/shape-15@2x.93783652.png";